import { useInfraContext } from '@lemonade-hq/nuiza';
import type { UniclientStepPresentation, URLProps } from '@lemonade-hq/uniclient-chat';
import { parseUniclientPresetUrl, PresetSubdomainError } from '@lemonade-hq/uniclient-chat';
import { useCallback } from 'react';
import type { WizardChatEnginePersistenceProps } from '../persistence/WizardChatEnginePersistenceProvider';

export interface UniclientPersistence {
  readonly params: WizardChatEnginePersistenceProps<UniclientStepPresentation> | null;
  readonly error: Error | null;
}

type GetUniclientPersistenceFn = (url: URLProps) => UniclientPersistence;

export const useGetUniclientPersistence = (): GetUniclientPersistenceFn => {
  const { env, envId } = useInfraContext();
  return useCallback(
    (url: URLProps) => {
      try {
        const parsedParams = parseUniclientPresetUrl(url, env, envId);
        return {
          params: parsedParams,
          error: null,
        };
      } catch (e: unknown) {
        if (e instanceof PresetSubdomainError) {
          return {
            params: null,
            error: null,
          };
        }

        return {
          params: null,
          error: e as Error,
        };
      }
    },
    [env, envId],
  );
};
